import React from 'react';
import { TableCell } from 'types/common/table';
import { AccessibleGroup } from 'types/member/memberCloset';
import { groupPlanMap, paymentGatewayTypeLabel } from 'constants/plansales/billing';
import { memberTypeLabel } from 'constants/member/closet';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { paymentMethodName } from 'constants/groups/filter';
import { NULL_TEXT } from 'constants/common';

export const memberClosetTableColumn: TableCell<AccessibleGroup>[] = [
  {
    align: 'center',
    name: 'No.',
    width: '5%',
    key: 'Group ID',
    render: data => <GroupIdAnchor href={`/groups/${data.groupId}`}>{data.groupId}</GroupIdAnchor>,
  },
  {
    align: 'center',
    name: 'Group Name',
    width: '15%',
    key: 'groupName',
    render: data => data.groupName,
  },
  {
    align: 'center',
    name: 'Plan Type',
    width: '5%',
    key: 'planType',
    render: data => groupPlanMap[data.planType],
  },
  {
    align: 'center',
    name: 'Payment Method',
    width: '5%',
    key: 'paymentMethod',
    render: data => {
      if (!data?.paymentGatewayType) return NULL_TEXT;
      return paymentMethodName[data.paymentGatewayType];
    },
  },
  {
    align: 'center',
    name: 'Permission',
    width: '5%',
    key: 'permission',
    render: data => memberTypeLabel[data.memberType],
  },
  {
    align: 'center',
    name: 'Invited Date',
    width: '5%',
    key: 'invitedAt',
    render: data => dayjs(data.invitedAt).format('YYYY-MM-DD'),
  },
];

const GroupIdAnchor = styled.a`
  cursor: pointer;
  color: inherit;
`;
